const $ = require('jquery')
let mixitup = require('mixitup')

if($('#js-container-mixitup').length > 0)
{
    mixitup('#js-container-mixitup', {
        animation: {
            duration: 300
        },
        selectors: {
            target: '.js-mix'
        }
    })
}
